// The FRONTEND face of the client config seam — Zebra Internal.
//
// The '@client/config' vite alias resolves HERE in this fork. This file is
// a full replacement of the product's
// modules/infrastructure/config/frontend/client.config.js, never merged
// with it: when a product merge adds an export there, add it here too or
// the build goes RED (coupling: client-config-new-export).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js
// (the server-side seam). The config suite asserts the two never drift —
// edit BOTH or the runner goes RED.

export const BRAND_NAME = 'Zebra Innovation';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Zebra Innovation — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

// Must match a group name in the site's data (permission checks, admin UI).
export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces (see the server seam's workspacesEnabled).
export const WORKSPACES_ENABLED = false;

// Browser storage namespace (localStorage, BroadcastChannel).
export const STORAGE_PREFIX = 'zebra-internal';

// The architectural hierarchy (see ../config/client.config.js).
export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
// Compared case-sensitively by several read paths (coupling: link-case).
export const LINK_TYPE_NAME = 'Hierarchy';

// The field kanban groups/colours by — null until a board exists.
export const WPO_FIELD = null;

// Accent colour as RGB (JS canvas + generated chrome).
export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

// Client Customs proxy host allowlist (enforced server-side; mirrored here
// so the seam stays one shape on both faces).
export const CUSTOMS_ALLOWED_HOSTS = [];
